import React from 'react'
import axios from '@/utils/myAxios'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { tableSummaries, isMobileDevice } from '@/utils/utils'
import {
    InputNumber,
    Button,
    Table,
    message,
    Modal,
    Select,
    Form,
    Pagination,
} from 'antd'

// 表单数据
const formData = {
    currency_code: undefined,
    rate: undefined,
}

export default class LocalCurrencyRatio extends React.Component {
    state = {
        loading: false, // 是否加载中
        recordLoading: false, // 记录是否加载中
        show: false, // 新增弹窗
        showRecord: false, // 记录弹窗
        type: undefined, // 弹窗类型
        recordType: undefined, // 记录类型 
        title: undefined, // 弹窗标题
        recordTitle: undefined, // 记录弹窗标题
        formData: { ...formData }, // 表单数据
        data: [], // 表格数据
        recordData: [], // 记录表格数据
        areaList: [], // 地区列表,
        selectedData: {}, // 选中的表格数据
    };

    componentDidMount () {
        this.fetchData()
        this.fetchAreaList()
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true })
        axios
            .get('/v1/api/local_coin/union_rate_conf_list')
            .then((res) => {
                this.setState({
                    loading: false,
                    data: res.data || []
                })
            })
    };

    /**
     * 获取地区列表
     */
    fetchAreaList = () => {
        axios
            .get('/v1/api/local_coin/union_zone_list')
            .then((res) => {
                this.setState({
                    areaList: res.data || []
                })
            })
    };

    /**
     * 获取记录数据
     */
    fetchRecordData = () => {
        this.setState({ recordLoading: true });
        axios
            .get("/v1/api/local_coin/union_rate_change_log", {
                params: {
                    currency_code: this.state.selectedData.currency_code
                }
            })
            .then((res) => {
                this.setState({
                    recordLoading: false,
                    recordData: res.data || [],
                });
            });
    };

    /**
     * 新增、编辑
     */
    handleAddOrEdit = () => {
        this.formRef.props.form.validateFields((err, values) => {
            if (!err) {
                axios
                    .post('/v1/api/local_coin/set_union_rate_conf', {
                        id: this.state.type === 'edit' ? this.state.selectedData.id : undefined,
                        currency_code: values.currency_code,
                        rate: values.rate,
                    })
                    .then((res) => {
                        if (res.code === 1) {
                            if (this.state.type === 'edit') {
                                message.success(this.props.language["editSuccessMessage"])
                            } else {
                                message.success(this.props.language["createSuccessMessage"])
                            }
                            this.fetchData()
                            this.handleClose()
                        }
                    })
            }
        })
    };

    /**
     * 显示弹窗
     */
    handleShow = (type, item) => {
        if (type === 'add') {
            // 新增
            this.setState({
                type,
                show: true,
                title: this.props.language['add'],
            })
        } else if (type === 'edit') {
            // 编辑
            this.setState({
                type,
                show: true,
                title: this.props.language['edit'],
                formData: {
                    currency_code: item.currency_code,
                    rate: item.rate,
                },
                selectedData: { ...item },
            })
        } else if (type === 'record') {
            // 记录
            this.setState(
                {
                    recordType: type,
                    showRecord: true,
                    recordTitle: this.props.language["record"],
                    selectedData: { ...item },
                },
                () => this.fetchRecordData()
            );
        }
    }

    /**
     * 关闭弹窗
     */
    handleClose = () => {
        this.formRef.props.form.resetFields()
        this.setState({ show: false, formData: { ...formData } });
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <Button type="primary" ghost onClick={() => this.handleShow('add')}>
                        {this.props.language["add"]}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={false}
                        loading={this.state.loading}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column align="center" title="ID" dataIndex="id" />
                        <Table.Column align="center" title={this.props.language["createTime"]} dataIndex="created_at" />
                        <Table.Column align="center" title={this.props.language["updateTime"]} dataIndex="updated_at" />
                        <Table.Column align="center" title={this.props.language["area"]} dataIndex="" render={(item) => `${item.currency_name}（${item.currency_code}）`} />
                        <Table.Column align="center" title={`${this.props.language["proportion"]}（${this.props.language["proportionDescription"]}）`} dataIndex="rate" />
                        <Table.Column
                            align="center"
                            title={this.props.language["operation"]}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : 'right'}
                            width={220}
                            render={(item) => (
                                <>
                                    <Button
                                        type="primary"
                                        ghost
                                        onClick={() => this.handleShow('edit', item)}
                                    >
                                        {this.props.language["edit"]}
                                    </Button>
                                    <Button
                                        className="ml10"
                                        type="default"
                                        onClick={() => this.handleShow('record', item)}
                                    >
                                        {this.props.language["record"]}
                                    </Button>
                                </>
                            )}
                        />
                    </Table>
                </div>

                {/* 表单弹窗 */}
                <FormModal
                    {...this.props}
                    visible={this.state.show}
                    type={this.state.type}
                    title={this.state.title}
                    formData={this.state.formData}
                    areaList={this.state.areaList}
                    onOk={this.handleAddOrEdit}
                    onCancel={this.handleClose}
                    wrappedComponentRef={(formRef) => (this.formRef = formRef)}
                />

                {/* 记录弹窗 */}
                <RecordModal
                    {...this.props}
                    visible={this.state.showRecord}
                    title={this.state.recordTitle}
                    loading={this.state.recordLoading}
                    recordData={this.state.recordData}
                    fetchRecordData={this.fetchRecordData}
                    onCancel={() => this.setState({ showRecord: false })}
                    onChange={(current, pageSize) =>
                        this.hanldeChangePage({ current, pageSize }, "record")
                    }
                />
            </div>
        )
    }
}

/**
 * 表单弹窗
 */
const FormModal = Form.create({ name: 'form_model' })(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator, getFieldValue } = this.props.form
            return (
                <Modal
                    maskClosable={false}
                    width={600}
                    title={this.props.title}
                    visible={this.props.visible}
                    onOk={this.props.onOk}
                    onCancel={this.props.onCancel}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: '70vh',
                        overflowY: 'auto'
                    }}
                >
                    <div className="container-content">
                        <Form>
                            <Form.Item label={this.props.language["area"]}>
                                {getFieldDecorator('currency_code', {
                                    rules: [
                                        {
                                            required: true,
                                            message: this.props.language["areaVerify"]
                                        }
                                    ],
                                    initialValue: this.props.formData.currency_code
                                })(
                                    <Select
                                        disabled={this.props.type === 'edit'}
                                        allowClear
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder={
                                            this.props.language[
                                            'areaPlaceholder'
                                            ]
                                        }
                                    >
                                        {this.props.areaList.map(
                                            (item, index) => (
                                                <Select.Option
                                                    key={index}
                                                    value={item.code}
                                                >
                                                    {item.name}
                                                </Select.Option>
                                            )
                                        )}
                                    </Select>
                                )}
                            </Form.Item>
                            <Form.Item label={`${this.props.language["proportion"]}（${this.props.language["proportionDescription"]}）`}>
                                {getFieldDecorator('rate', {
                                    rules: [
                                        {
                                            required: true,
                                            message: this.props.language["proportionVerify"]
                                        }
                                    ],
                                    initialValue: this.props.formData.rate
                                })(
                                    <InputNumber
                                        precision={0}
                                        min={0}
                                        max={100000000}
                                        placeholder={this.props.language["proportionPlaceholder"]}
                                    />
                                )}
                            </Form.Item>
                        </Form>
                    </div>
                </Modal>
            )
        }
    }
)

/**
 * 记录弹窗
 */
class RecordModal extends React.Component {
    render () {
        return (
            <Modal
                maskClosable={false}
                width={1600}
                title={this.props.title}
                visible={this.props.visible}
                onCancel={this.props.onCancel}
                centered={isMobileDevice()}
                bodyStyle={{
                    maxHeight: "70vh",
                    overflowY: "auto",
                }}
                footer={false}
            >
                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.props.recordData}
                        pagination={false}
                        loading={this.props.loading}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column align="center" title="ID" dataIndex="id" />
                        <Table.Column align="center" title={this.props.language["operationTime"]} dataIndex="created_at" />
                        <Table.Column align="center" title={this.props.language["area"]} dataIndex="" render={(item) => `${item.currency_name}（${item.currency_code}）`} />
                        <Table.Column align="center" title={`${this.props.language["oldProportion"]}（${this.props.language["proportionDescription"]}）`} dataIndex="old_rate" />
                        <Table.Column align="center" title={`${this.props.language["newProportion"]}（${this.props.language["proportionDescription"]}）`} dataIndex="new_rate" />
                    </Table>
                </div>
            </Modal>
        );
    }
}

